import { render, staticRenderFns } from "./graduateRegistForm.vue?vue&type=template&id=6ae4506a&scoped=true"
import script from "./graduateRegistForm.vue?vue&type=script&lang=js"
export * from "./graduateRegistForm.vue?vue&type=script&lang=js"
import style0 from "./graduateRegistForm.vue?vue&type=style&index=0&id=6ae4506a&lang=scss&scoped=true"
import style1 from "./graduateRegistForm.vue?vue&type=style&index=1&id=6ae4506a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae4506a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ae4506a')) {
      api.createRecord('6ae4506a', component.options)
    } else {
      api.reload('6ae4506a', component.options)
    }
    module.hot.accept("./graduateRegistForm.vue?vue&type=template&id=6ae4506a&scoped=true", function () {
      api.rerender('6ae4506a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/concatTeacher/graduateRegistForm.vue"
export default component.exports